import { render, staticRenderFns } from "./kf_course.vue?vue&type=template&id=544a7de2&scoped=true&"
import script from "./kf_course.vue?vue&type=script&lang=js&"
export * from "./kf_course.vue?vue&type=script&lang=js&"
import style0 from "./kf_course.vue?vue&type=style&index=0&id=544a7de2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544a7de2",
  null
  
)

export default component.exports